module.exports = __webpack_public_path__ + "h5/img/global_banner.d533a4ee.png";